import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'
import { buildEntitiesFromDescriptionPrompt } from '@/ai/prompts'

export const generateEntitiesFromDescription = async ({
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  userDescription,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildEntitiesFromDescriptionPrompt({
    workflow,
    svgGraph,
    svgLanes,
    cardTypes,
    userDescription,
    stream
  })

  try {
    if (stream) {
      return await streamJsonResponses({
        messages,
        aiVersion: workflow.aiVersion,
        onChunkReceived,
        signal: abortController?.signal
      })
    } else {
      const response = await fetchJsonResponse({
        messages,
        aiVersion: workflow.aiVersion,
        signal: abortController?.signal
      })

      return response || null
    }
  } catch (error) {
    return null
  }
}
